<template>
    <div class="ticket-stack__item-summary">
        <Status
            :status="status"
            :numEventsLeft="numEventsLeft"
            :liveIndicator="hasOngoingEvents"
        />
        <div class="delimiter--transparent"></div>
        <div
            :title="coefficient | twoDecimals"
            class="ticket-stack__item--quote"
        >
            {{ coefficient | twoDecimals }}
        </div>
        <div class="ticket-stack__item--stake">
            {{ stake | twoDecimals }}
        </div>
        <div class="ticket-stack__item--potential-win">
            {{ payout | twoDecimals }}
            <span class="ticket-stack__item--currency">
                {{ $t('currencyAbbreviation') }}
            </span>
        </div>
    </div>
</template>

<script>
    import Status from '@modules/shared/tickets/Status.vue';

    export default {
        name: 'TicketSummary',
        inheritAttrs: false,
        props: {
            potentialWin: {
                type: Number,
                required: true,
            },
            payoff: {
                type: Number,
                required: true,
            },
            isWon: {
                type: Boolean,
                required: false,
                default: true,
            },
            stake: {
                type: Number,
                required: true,
            },
            coefficient: {
                type: Number,
                required: true,
            },
            status: {
                type: String,
                required: true,
            },
            numEventsLeft: {
                type: Number,
                required: true
            },
            hasOngoingEvents: {
                type: Boolean,
                required: false,
                default: false
            },
        },
        computed: {
            payout() {
                return this.isWon ? this.payoff : this.potentialWin;
            }
        },
        components: {
            Status,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/ticketsWidget/components/TicketSummary.vue